import axios from 'axios';
import { hasAuthAccessParams } from '../types/guards';
import { processResponse, processError, privateRequestParams } from '../utils';
export default class HeroPillOptionsAPI {
    static getPillOptionsStub(accessParams, params) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + `drugs/stubs`, {
            search: params.search_string,
        }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getPillOptionsName(accessParams, params) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT +
            `drugs/generic-branded-names`, {
            search: params.stub,
        }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getPillOptionsForm(accessParams, params) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + `drugs/forms`, {
            search: params.name,
            btg: params.is_generic ? 'generic' : 'branded',
        }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getPillOptionsStrength(accessParams, params) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + `drugs/strengths`, {
            search: params.name,
            form: params.form,
            btg: params.is_generic ? 'generic' : 'branded',
        }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
}
//# sourceMappingURL=index.js.map